export default "__VITE_ASSET__NKvW7AAW__"